import { createActions } from 'redux-actions';

const actions = createActions({
  APPLICATION_MESSAGES_LOADED: (data) => data,
  CLEAR_ALL_CUSTOMER_CACHE: () => { },
  CLEAR_USER_CACHE: () => { },
  CONTENTFUL_PAGE_LOADED: (data) => data,
  DIALOG_MESSAGE_UPDATED: (data) => data,
  DISMISS_ALERT: () => ({}),
  GENERAL_DATA_LOADED: (data) => data,
  GET_CONTENTFUL_PAGE: (data) => data,
  GET_GENERAL_DATA: () => { },
  GET_LANGUAGES: () => { },
  GET_PUBLIC_SIDE_IMAGE: () => { },
  GET_SHARE_POST_DATA: (data) => data,
  GET_SHARE_POST_DATA_FAILED: () => { },
  GET_SHARE_POST_DATA_SUCCESS: (data) => data,
  LANGUAGES_LOADED_FAILED: () => { },
  LANGUAGES_LOADED_SUCCESS: (data) => data,
  LINK_MESSAGE_SENT: (data) => (data),
  PUBLIC_SIDE_IMAGE_LOADED: (data) => (data),
  SAVE_LANGUAGE_PREFERENCE: (data) => data,
  SEND_LINK_MESSAGE: (data) => (data),
  SEND_MESSAGE_RESTARTED: () => ({}),
  SHOW_ALERT: (data) => ({ data }),
  SHOW_GENERIC_ERROR: (data) => data,
});

export const {
  applicationMessagesLoaded,
  clearAllCustomerCache,
  clearUserCache,
  contentfulPageLoaded,
  dialogMessageUpdated,
  dismissAlert,
  generalDataLoaded,
  getContentfulPage,
  getGeneralData,
  getLanguages,
  getPublicSideImage,
  getSharePostData,
  getSharePostDataFailed,
  getSharePostDataSuccess,
  languagesLoadedFailed,
  languagesLoadedSuccess,
  linkMessageSent,
  publicSideImageLoaded,
  saveLanguagePreference,
  sendLinkMessage,
  sendMessageRestarted,
  showAlert,
  showGenericError,
} = actions;
